import { APIOverrides } from "../../ApiOverrides";
import axios from "axios"
import type { AthleteProps, EventProps, LeagueProps, MarketProps, MatchProps, OrderProps, OrderResponseProps, PlayerFilterProps, PublicPlayerProps, TeamProps, TournamentProps } from "../../types";

let AUTH_SVC_API = ''
let EVENT_SVC_API = ''
//let TP_SVC_API = ''
let MK_SVC_API = ''

export const BetMatchApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        //TP_SVC_API = endpoints['TP_SVC_API'] as string;
        EVENT_SVC_API = endpoints['EVENT_SVC_API'] as string;
        AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;
        MK_SVC_API = endpoints['MK_SVC_API'] as string;
    },
    getMyOrderFilters: async(player_id:string, status?:string, pinned?:boolean):Promise<PlayerFilterProps[]> => {
        try {
            const resp = await axios.get(`${MK_SVC_API}/v1/filters/player/${player_id}?status=${status}&pinned=${pinned}`)
            return resp.data.player_filters
        } catch (e) {
            console.log(e)
            return []
        }
    },
    getPlayersByPlayerIds : async(player_ids:string[]):Promise<PublicPlayerProps[]> => {
        if(player_ids.length == 0){ return [] }
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/bulk/get`, { player_ids })
            return resp.data.players
        } catch (e) {
            return []
        }
    },
    searchPlayersByValue: async(search_value:string, offset:number):Promise<PublicPlayerProps[]> => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/player/search/value`, { search_value, offset })
            return resp.data.players
        } catch (e) {
            return []
        }
    },
    getPlayerFilterById: async(player_filter_id:string):Promise<PlayerFilterProps | undefined> => {
        try {
            const resp = await axios.get(`${MK_SVC_API}/v1/filters/filter/${player_filter_id}`);
            return resp.data.player_filter
        } catch (e) {
            console.log(e);
            return undefined
        }
    },
    runPlayerFilter: async(player_filter_id:string):Promise<OrderProps[]> => {
        try {
            const resp = await axios.get(`${MK_SVC_API}/v1/filters/run/${player_filter_id}`);
            return resp.data.orders
        } catch (e) {
            console.log(e);
            return []
        }
    },
    createPlayerFilter: async(player_filter:PlayerFilterProps):Promise<PlayerFilterProps|undefined> => {
        try {
            const resp = await axios.post(`${MK_SVC_API}/v1/filters/player/create`, { player_filter })
            return resp.data.player_filter
        } catch (e) {
            console.log(e);
            return undefined
        }
    },
    updatePlayerFilter: async(player_filter:PlayerFilterProps):Promise<PlayerFilterProps | undefined> => {
        try {
            const resp = await axios.post(`${MK_SVC_API}/v1/filters/player/update`, { player_filter })
            return resp.data.player_filter
        } catch (e) {
            console.log(e);
            return undefined
        }
    },
    deletePlayerFilter: async(player_filter_id:string):Promise<PlayerFilterProps | undefined> => {
        try {
            const resp = await axios.post(`${MK_SVC_API}/v1/filters/player/delete`, { player_filter_id })
            return resp.data.player_filter
        } catch (e) {
            console.log(e);
            return undefined
        }
    },
    saveBetMatchResponse: async(order_response:OrderResponseProps):Promise<boolean> => {
        try {
            await axios.post(`${MK_SVC_API}/v1/filters/order/response/create`, { order_response })
            return true
        } catch (e) {
            console.log(e);
            return false
        }
    },
    getEventsByEventIds: async(event_ids:string[]):Promise<EventProps[]> => {
        try {
            if(event_ids.length == 0){ return [] }
            const resp = await axios.post(`${EVENT_SVC_API}/v1/events/bulk/get`, { attribute:'event_id', values: event_ids })
            return resp.data.events
        } catch (e) {
            return []
        }
    },
    getMatchesByMatchIds: async(match_ids:string[]):Promise<MatchProps[]> => {
        try {
            if(match_ids.length == 0){ return [] }
            const resp = await axios.post(`${EVENT_SVC_API}/v1/matches/bulk/get`, { attribute: 'match_id', values: match_ids })
            return resp.data.matches
        } catch (e) {
            return []
        }

    },
    getAthletesByIds : async(athlete_ids:string[]):Promise<AthleteProps[]> => {
        try {
            if(athlete_ids.length == 0){ return [] }
            const resp = await axios.post(`${EVENT_SVC_API}/v1/athletes/bulk/get`, { attribute: 'athlete_id', values: athlete_ids })
            return resp.data.athletes
        } catch (e) {
            return []
        }
    },
    getTournamentsByTournamentIds: async(tournament_ids:string[]):Promise<TournamentProps[]> => {
        try {
            if(tournament_ids.length == 0){ return [] }
            const resp = await axios.post(`${EVENT_SVC_API}/v1/tournaments/bulk/get`, { attribute: 'event_id', values: tournament_ids })
            return resp.data.tournaments
        } catch (e) {
            return []
        }
    },
    getTeamsByIds: async(team_ids:string[]) => {
        try {
            if(team_ids.length == 0){ return [] }
            const resp = await axios.post(`${EVENT_SVC_API}/v1/teams/bulk/get`, { attribute:'team_id', values: team_ids })
            return resp.data.teams
        } catch (e) {
            return []
        }

    },
    searchAthletes: async( search_value:string, offset:number, league_ids?:string[] ):Promise<AthleteProps[]> => {
        try {
            const resp = await axios.post(`${EVENT_SVC_API}/v1/athletes/search`, { search_value, offset, league_ids })
            return resp.data.athletes
        } catch (e) {
            return []
        }
    },
    searchTeams: async( search_value:string, offset:number, league_ids?:string[] ):Promise<TeamProps[]> => {
        try {
            const resp = await axios.post(`${EVENT_SVC_API}/v1/teams/search`, { search_value, offset, league_ids })
            return resp.data.teams
        } catch (e) {
            return []
        }
    },
    getMarkets:async():Promise<MarketProps[]> => {
        try {
            const resp = await axios.get(`${MK_SVC_API}/v1/markets/all`);
            return resp.data.markets
        } catch (e) {
            console.log(e)
            return []
        }
    },
    getLeagues:async():Promise<LeagueProps[]> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/leagues`);
            return resp.data.leagues
        } catch (e) {
            return []
        }
    },
}



export const BetMatchHelpers = {
    filterMarkets: (markets:MarketProps[], leagues:LeagueProps[], draft_filter?:PlayerFilterProps):MarketProps[] => {
        if(!draft_filter){ return [] }
        let filtered_markets = markets.filter(m => draft_filter.filter.market_types == 'event' ? m.type != 'Stat' : m.type == 'Stat');
        if(draft_filter.filter.league_ids.length > 0){
            let leagues_added = leagues.filter(l => draft_filter.filter.league_ids.map(id => id.toString()).includes(l.league_id.toString()))
            let default_markets:string[] = []
            leagues_added.map(l => { 
                if(!l.default_markets){ return }
                l.default_markets.map(dm => default_markets.push(dm.market_id.toString()))
            })
            filtered_markets = filtered_markets.filter(m => default_markets.includes(m.market_id.toString()))
        }
        return filtered_markets
    }
}